import produce from 'immer';
import {
  GET_COUPON_LIST_START,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_LIST_FAILED,
  GENERATE_COUPON_FOR_EMAIL_START,
  GENERATE_COUPON_FOR_EMAIL_SUCCESS,
  GENERATE_COUPON_FOR_EMAIL_FAILED,
  GENERATE_COUPON_RULE_START,
  GENERATE_COUPON_RULE_SUCCESS,
  GENERATE_COUPON_RULE_FAILED,
  SET_EDITABLE_RULE,
  UPDATE_COUPON_RULE_COMBINED_START,
  UPDATE_COUPON_RULE_COMBINED_SUCCESS,
  UPDATE_COUPON_RULE_COMBINED_FAILED,
  GET_COUPON_RULES_START,
  GET_COUPON_RULES_SUCCESS,
  GET_COUPON_RULES_FAILED,
  GET_COUPON_CODE_START,
  GET_COUPON_CODE_SUCCESS,
  GET_COUPON_CODE_FAILED,
  CREATE_COUPON_RULE_COMBINED_START,
  CREATE_COUPON_RULE_COMBINED_SUCCESS,
  CREATE_COUPON_RULE_COMBINED_FAILED,
  DELETE_COUPON_RULE_START,
  DELETE_COUPON_RULE_SUCCESS,
  DELETE_COUPON_RULE_FAILED
} from '../actions/coupon_rules';

import {
  GET_USER_PROFILE_SUCCESS,
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';

import {
  ADD_USER_STORE_SUCCESS
} from '../actions/admin';


const initialState = {
  couponList: [],
  couponRules: [],
  allCouponRulesList: [],
  couponCodeData: {},
  couponRulesTotalCount: 0,
  newCouponRule: {
    name: '',
    description: '',
    is_active: 1,
    uses_per_coupon: 0,
    aw_coupongenerator_expiration: 0,
    simple_action: 'by_percent',
    discount_amount: 0,
    simple_free_shipping: '0',
    customer_group_ids: [],
    actions: [],
    website_ids: []
  },
  websiteId: [],
  editableRule: {
    name: '',
    description: '',
    is_active: 1,
    uses_per_coupon: 0,
    aw_coupongenerator_expiration: 0,
    simple_action: 'by_percent',
    discount_amount: 0,
    simple_free_shipping: '0',
    customer_group_ids: [],
    actions: [],
    website_ids: []
  },
  loadingCouponList: false,
  loadingCoupon: false,
  loadingCouponRules: false,
  loadingGenerateCouponRule: false,
  loadingGenerateCoupon: false,
  loadingUpdateCouponRule: false,
  loadingProfile: false
};

const formReducer = produce((state: ICouponRulesState = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_LIST_START: {
      state.loadingCouponList = true;
      break;
    }
    case GET_COUPON_LIST_SUCCESS: {
      const { data } = action;

      state.couponList = data.items;
      state.loadingCouponList = false;

      break;
    }
    case GET_COUPON_LIST_FAILED: {
      state.loadingCouponList = false;
      break;
    }

    case GENERATE_COUPON_FOR_EMAIL_START: {
      state.loadingGenerateCoupon = true;
      break;
    }
    case GENERATE_COUPON_FOR_EMAIL_SUCCESS: {
      const { data: { coupon } } = action;

      state.couponList = [...state.couponList, coupon];

      state.loadingGenerateCoupon = false;
      break;
    }
    case GENERATE_COUPON_FOR_EMAIL_FAILED: {
      state.loadingGenerateCoupon = false;
      break;
    }

    case GET_USER_PROFILE_SUCCESS: {
      const { data } = action;

      if (data.user.stores.length) {
        state.newCouponRule.website_ids = [data.user.stores[0].storeId];
        state.websiteId = [data.user.stores[0].storeId];
      }

      state.loadingProfile = false;
      break;
    }

    case GENERATE_COUPON_RULE_START: {
      state.loadingGenerateCouponRule = true;
      break;
    }

    case GENERATE_COUPON_RULE_SUCCESS: {
      const { data } = action;

      state.couponRules = [...state.couponRules, data];
      state.newCouponRule = initialState.newCouponRule;
      state.loadingGenerateCouponRule = false;
      break;
    }

    case GENERATE_COUPON_RULE_FAILED: {
      state.loadingGenerateCouponRule = false;
      break;
    }

    case UPDATE_COUPON_RULE_COMBINED_START: {
      state.loadingUpdateCouponRule = true;
      break;
    }

    case UPDATE_COUPON_RULE_COMBINED_SUCCESS: {
      const { updatedCouponRule } = action;

      state.allCouponRulesList = state.allCouponRulesList.map((rule) => rule.rule_id === updatedCouponRule.rule_id ? updatedCouponRule : rule);
      state.editableRule = initialState.editableRule;
      state.loadingUpdateCouponRule = false;

      break;
    }

    case UPDATE_COUPON_RULE_COMBINED_FAILED: {
      state.loadingUpdateCouponRule = false;
      break;
    }

    case GET_COUPON_RULES_START: {
      state.loadingCouponRules = true;
      break;
    }

    case GET_COUPON_RULES_SUCCESS: {
      const { salesRules } = action.rulesData;
      const { coupons } = action.couponData;

      const updatedSalesRules = salesRules.items.map((salesRule) => {
        const { rule_id } = salesRule;
        const ruleCoupon = coupons.items.find((coupon) => coupon.rule_id === rule_id);
        return {
          ...salesRule,
          coupon_code: ruleCoupon || null
        };
      });

      state.allCouponRulesList = updatedSalesRules;
      state.couponRulesTotalCount = salesRules.total_count;
      state.loadingCouponRules = false;

      break;
    }

    case GET_COUPON_RULES_FAILED: {
      state.loadingCouponRules = false;
      break;
    }

    case GET_COUPON_CODE_START: {
      state.loadingCoupon = true;
      break;
    }

    case GET_COUPON_CODE_SUCCESS: {
      const { items } = action.data.coupons;
      const { rule_id } = action;

      state.couponCodeData[rule_id] = items;
      state.loadingCoupon = false;

      break;
    }

    case GET_COUPON_CODE_FAILED: {
      state.loadingCoupon = false;
      break;
    }

    case CREATE_COUPON_RULE_COMBINED_START: {
      state.loadingGenerateCouponRule = true;
      break;
    }

    case CREATE_COUPON_RULE_COMBINED_SUCCESS: {
      state.loadingGenerateCouponRule = false;

      break;
    }

    case CREATE_COUPON_RULE_COMBINED_FAILED: {
      state.loadingGenerateCouponRule = false;
      break;
    }

    case DELETE_COUPON_RULE_START: {
      state.loadingCouponRules = true;
      break;
    }

    case DELETE_COUPON_RULE_SUCCESS: {
      const { id } = action;
      state.allCouponRulesList = state.allCouponRulesList.filter((rule) => rule.rule_id != id);
      state.couponRulesTotalCount = state.couponRulesTotalCount - 1;
      state.loadingCouponRules = false;

      break;
    }

    case DELETE_COUPON_RULE_FAILED: {
      state.loadingCouponRules = false;
      break;
    }


    case SET_EDITABLE_RULE: {
      const { rule } = action;
      state.editableRule = rule;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      const { data } = action;

      state.newCouponRule['website_ids'] = [data.user.stores[0].storeId];
      state.websiteId = [data.user.stores[0].storeId];
      state.newCouponRule['customer_group_ids'] = [];

      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      const { store } = action.data;

      if (store?.storeId) {
        state.newCouponRule['website_ids'] = [store.storeId];
        state.websiteId = [store.storeId];
      }

      state.newCouponRule['customer_group_ids'] = [];
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
